import React, { useContext } from 'react';
import { PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';

import RuleDialog from '@totem/components/rulesEngine/report/ruleDialog';
import RulesContext from '@totem/components/rulesEngine/report/rulesContext';
import RulesTable from '@totem/components/rulesEngine/report/rulesTable';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

export const RulesExtra = () => {
  const { rulesData, onRefresh, onAdd } = useContext(RulesContext);
  const { userProfile } = useContext(UserProfileContext);

  const canEdit = permissions.ruleAdministrator.hasPermissions(userProfile);

  return (
    <Space>
      <RecordCountBadge count={rulesData ? rulesData.length : 0} />
      {canEdit && (
        <Tooltip title="Add Rule">
          <Button icon={<PlusOutlined />} onClick={onAdd} type="primary">
            Add
          </Button>
        </Tooltip>
      )}
      <Tooltip title="Refresh">
        <Button icon={<ReloadOutlined />} onClick={onRefresh} />
      </Tooltip>
    </Space>
  );
};

const RulesLayout = () => (
  <>
    <RulesTable />
    <RuleDialog />
  </>
);

export default RulesLayout;
